<template>
  <div>
    <h4 class="text-center text-lighter font-weight-normal mt-5 mb-5 mb-0">
      {{ $t('phrase.register_as') }}
    </h4>

    <div v-if="!organisationType">
      <div class="mb-3">
        <v-button
          id="register-organisation-advertiser"
          text="word.advertiser"
          :block="true"
          size="lg"
          icon="building"
          @click="goTo('default')"
        />
      </div>

      <div class="mb-3">
        <v-button
          id="register-organisation-agency"
          :text="$tc('word.agency', 1)"
          :translate-text="false"
          :block="true"
          size="lg"
          icon="video"
          @click="goTo('agency')"
        />
      </div>
    </div>
    <div v-else>
      <v-register-form
        :small-screen="true"
        :as-organisation="true"
        :organisation-type="organisationType"
        :total-price="totalPrice"
        @authenticated="(payload) => {$emit('authenticated', payload)}"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import RegisterForm from '@/common/components/auth/RegisterForm.vue';
import { b64ToUtf8 } from '@/common/utils/encode';

export default {
  name: 'RegisterOrganisation',
  data() {
    return {
      organisationType: null,
      totalPrice: null,
    };
  },
  components: {
    'v-button': Button,
    'v-register-form': RegisterForm,
  },
  methods: {
    goTo(orgType) {
      this.$router.push({
        name: 'register',
        params: { as: 'organisation' },
        query: {
          type: orgType,
          ...this.$route.query,
        },
      });
    },
  },
  created() {
    if (this.$route.query.type === 'agency') {
      this.organisationType = 'media_agency';

      // When a media agencies register, they have to pay a fee;
      this.totalPrice = 500;
    } else if (this.$route.query.type === 'default') {
      this.organisationType = 'default';
      this.totalPrice = 0;
    }

    if (this.$route.query.p) {
      this.totalPrice = b64ToUtf8(this.$route.query.p);
    }
  },
};
</script>
